import {
  CLOUD_PROVIDER,
  SERVICE_WORKER_LISTENER_TYPES
} from "@base/common/constants/index.js";
import {
  postMessageToServiceWorker,
  registerServiceWorkerListenerTypes
} from "@base/common/libs/utils/index.js";
import { clearCache, DataService } from "../../libs/services/index.js";
import { requestNotificationPermission } from "../../libs/utils/notification.js";

export class CloudMessaging {
  firebase;
  accountId;

  async loadModule() {
    const [module] = await Promise.all([
      import("@firebase/app"),
      import("@firebase/messaging"),
      import("@firebase/auth"),
      import("@firebase/database")
    ]);
    return module.default;
  }

  async init(accountId, config) {
    this.firebase = await this.loadModule();
    if (!this.firebase.apps.length) {
      this.firebase.initializeApp(config);
    } else {
      this.firebase.app();
    }
    this.accountId = accountId;
    this.register();

    return this.firebase;
  }

  async registerMessaging() {
    const messaging = this.firebase?.messaging();
    if (messaging) {
      const [promise] = DataService.get(
        `/notification/2/${this.accountId}/device/settings`
      );
      const notificationSetting = await promise();
      const notificationPreference = Notification.permission;
      if (
        (notificationSetting?.PushNotification &&
          notificationPreference === "default" &&
          requestNotificationPermission()) ||
        notificationPreference === "granted"
      ) {
        this.getToken().catch((e) => {
          console.info("error while getting fbtoken", e);
        });
      }
      messaging.onMessage = (payload) => {
        console.info("$$$$$$$$$$$$$ ===> message is coming from firebasse ");
      };
      messaging.onTokenRefresh = () => {
        console.info("Token refresh triggered");
        this.getToken().catch((e) => {
          console.info("error while getting fbtoken", e);
        });
      };
    }
  }

  fbSignout() {
    let dbs = [
      "firebase-installations-database",
      "firebase-messaging-database"
    ];
    dbs.forEach((db) => {
      window?.indexedDB?.deleteDatabase?.(db);
    });
  }

  signout() {
    postMessageToServiceWorker({
      type: SERVICE_WORKER_LISTENER_TYPES.BASE_SIGNOUT
    });
    localStorage.setItem("isSessionExpired", true);
    clearCache();
    this.fbSignout();
  }

  register() {
    this.registerMessaging();
    registerServiceWorkerListenerTypes(
      SERVICE_WORKER_LISTENER_TYPES.BASE_SIGNOUT,
      this.fbSignout
    );
  }

  async getToken() {
    const messaging = this.firebase?.messaging();
    if (!messaging) {
      console.info("Token retrieving failed");
      return;
    }
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.ready;
      try {
        messaging.useServiceWorker(registration);
      } catch (e) {
        console.info("Service worker already registered");
      }
      const token = await messaging.getToken();
      if (token) {
        const [promise] = DataService.update(
          `/user/2/${this.accountId}/fcmtoken`,
          {
            data: { FCMToken: token }
          }
        );
        await promise();
      }
    } else {
      console.warn("Service worker is not available");
    }
  }
}

function getPushNotificationClient(name) {
  switch (name) {
    case CLOUD_PROVIDER.GCP:
      return new CloudMessaging();

    case CLOUD_PROVIDER.AWS:
      return new CloudMessaging();

    default:
      return new CloudMessaging();
  }
}

let config = window.accountDetails.AppConfig | {};

export let pushNotificationClient = getPushNotificationClient(config.Category);
